/* <wg-faq-tabs>: accessible tabbed FAQ.
   Tabs switch which category panel is visible; arrow keys move between tabs. */
(function () {
  if (customElements.get('wg-faq-tabs')) return;

  class WGFaqTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!this.tabs.length) return;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }
        });
      });

      this.select(0);
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        panel.toggleAttribute('hidden', i !== index);
      });
    }
  }

  customElements.define('wg-faq-tabs', WGFaqTabs);
})();
